/**
 * Study Overview Table - Popup Handler
 * Handles popup interactions for study attribute information
 */

(function () {
  /**
   * Initialize popup functionality
   */
  function initializePopups() {
    const overlay = document.querySelector(".popup-overlay");
    const attributeBtns = document.querySelectorAll(".study-attribute-btn");
    const popups = document.querySelectorAll(".study-popup");
    const closeBtns = document.querySelectorAll(".popup-close");

    // Open popup on attribute button click
    attributeBtns.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const popupLink = btn.getAttribute("data-popup-link");

        if (!popupLink) {
          console.warn("Button missing data-popup-link attribute");
          return;
        }

        // Find popup that matches this button's popup link ID
        const targetPopup = Array.from(popups).find((popup) => {
          const popupLinkAttr = popup.getAttribute("data-popup-link");
          return popupLinkAttr === popupLink;
        });

        if (targetPopup && overlay) {
          overlay.classList.remove("hidden");
          targetPopup.classList.remove("hidden");
        } else if (!targetPopup) {
          console.warn(`No popup found with data-popup-link="${popupLink}"`);
        }
      });
    });

    // Close popup on overlay click
    if (overlay) {
      overlay.addEventListener("click", () => {
        if (overlay) closeAllPopups(overlay, popups);
      });
    }

    // Close popup on close button click
    closeBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        if (overlay) closeAllPopups(overlay, popups);
      });
    });

    // Close popup on ESC key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && overlay) {
        closeAllPopups(overlay, popups);
      }
    });
  }

  /**
   * Close all popups and overlay
   * @param {Element} overlay - The popup overlay element
   * @param {NodeListOf<Element>} popups - All popup elements
   */
  function closeAllPopups(overlay, popups) {
    if (overlay) {
      overlay.classList.add("hidden");
    }
    popups.forEach((popup) => popup.classList.add("hidden"));
  }

  // Initialize on DOM load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initializePopups();
    });
  } else {
    // DOM already loaded
    initializePopups();
  }

  // Re-initialize when Shopify section is reloaded in theme editor
  if (typeof window.Shopify !== "undefined" && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      initializePopups();
    });
  }
})();
